import { useState, useEffect, useCallback } from 'react'

export const useSSE = endpoint => {
  const [data, setData] = useState(null)
  const [connected, setConnected] = useState(false)

  // Setup EventSource connection
  useEffect(() => {
    const source = new EventSource(endpoint)

    source.onopen = () => {
      setConnected(true)
    }

    source.onerror = error => {
      console.error('SSE connection error:', error)
      setConnected(false)
      // Connection will automatically reconnect
    }

    source.onmessage = event => {
      try {
        const parsedData = JSON.parse(event.data)
        setData(parsedData)
      } catch (error) {
        console.error('Error parsing SSE data:', error)
      }
    }

    // Clean up on unmount
    return () => {
      source.close()
    }
  }, [endpoint])

  // Reset data
  const clearData = useCallback(() => {
    setData(null)
  }, [])

  return { data, clearData, connected }
}
